import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import orderModule from './modules/order.js';
import userModule from './modules/user.js';

import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);
export default new Vuex.Store({
    modules: {
        app,
        order: orderModule,
        user: userModule
    },
    plugins: [createPersistedState({
        storage: window.sessionStorage
    })]
});
